import UIfx from "uifx";
import buzzer from "./Audio/Buzzer.mp3";

export const Buzzer = new UIfx(buzzer, {
  volume: 0.4
});
